import React from 'react';

const TimelineAcceptLiability = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.3"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <title>Accept Liability</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-577.000000, -1695.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Accept-Liability" transform="translate(0.000000, 792.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="file-alt-light" transform="translate(14.000000, 19.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M14.2857143,0 L1.71428571,0 C0.7675,0 0,0.7675 0,1.71428571 L0,14.2857143 C0,15.2325 0.7675,16 1.71428571,16 L14.2857143,16 C15.2325,16 16,15.2325 16,14.2857143 L16,1.71428571 C16,0.7675 15.2325,0 14.2857143,0 Z M14.2857143,14.2857143 L1.71428571,14.2857143 L1.71428571,1.71428571 L14.2857143,1.71428571 L14.2857143,14.2857143 Z M13.0048571,5.65271429 L6.84096429,11.7671429 C6.67292857,11.9338214 6.40157143,11.93275 6.23489286,11.7647143 L2.99271429,8.49628571 C2.82603571,8.32825 2.82710714,8.05689286 2.99517857,7.89017857 L3.80657143,7.08532143 C3.97460714,6.91864286 4.24596429,6.91971429 4.41264286,7.08778571 L6.54807143,9.24053571 L11.5963571,4.23282143 C11.7643929,4.06614286 12.03575,4.06721429 12.2024286,4.23525 L13.0072857,5.04660714 C13.1739643,5.21467857 13.1728929,5.48603571 13.0048571,5.65271429 Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineAcceptLiability;

